<template>
    <section class="section">

        <div class="container">
            <h2 class="subtitle"><router-link tag="a" :to="{name: 'products', params: {}}">Hot products</router-link></h2>
            <ProductCards :items="products" />
        </div>

        <div class="container">
            <nav class="pagination is-centered">
                <ul class="pagination-list">
                    <li>
                        {{currentPage+1 }} / {{ pages }}
                    </li>
                </ul>
                <div class="page-item" :class="{disabled: prevUrl === ''}">
                    <button class="pagination-previous" @click="checkPage(prevUrl)">Previous</button>
                </div>
                <div class="page-item" :class="{disabled: nextUrl === ''}">
                    <button class="pagination-next" @click="checkPage(nextUrl)">Next</button>
                </div>
            </nav>
        </div>
    </section>
</template>

<script>
import ProductCards from './cards/ProductCards';
import Api from '@/config/Api'

export default {
    components: {
        ProductCards
    },
    data() {
        return {
            products: [],
            currentPage: '',
            pages: '',
            prevUrl: '',
            nextUrl: ''
        }
    },
    computed: {
        country() {
            return this.$store.getters.getCountry
        }
    },
    created() {
        Api().get(`/api/${this.country}/products`).then(response => {
            this.products = response.data.products;
            this.currentPage = response.data.currentPage;
            this.pages = response.data.pages;
            this.nextUrl = response.data.nextUrl;
            this.prevUrl = response.data.prevUrl;
            console.log("herey_created", this.products);
            this.$store.commit('setContentLoaded', true); // then footer will be displayed
        });
    },
    sockets: { // Received from server via socket.io...
      updateStock: function(val){
        // console.log('____updateStock:',val);
        var productId = val.productId;
        var changes = val.changes;

        // var product = this.products.filter(x => x._id == productId);
        for (var i = 0; i < this.products.length; i++) {
            var product = this.products[i];
            if (product._id == productId) {
                    console.log('changing product ' + productId + ' to:', changes);
                    for (var j = 0; j < changes.length; j++) {
                        var change = changes[j];
                        Object.assign(product, change); 
                    }
                this.products[i] = product;
                break;
            }
        }
        // store.commit('updateStock', 40); //store.commit('updateStock', itemFromServer);
      }
    },
    methods: {
        checkPage(url) {
            Api().get(url).then(response => {
                console.log("checkPage url:",url);
                this.products = response.data.products;
                this.currentPage = response.data.currentPage;
                this.pages = response.data.pages;
                this.nextUrl = response.data.nextUrl;
                this.prevUrl = response.data.prevUrl;
            })
        }
    }
}
</script>

<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/Plays.vue